import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldCheck, X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Optional "Verify your age" nudge. Only shows when the per-environment flag
// `age_verification_prompt` is ON and the member isn't Verified 18+. Never blocks.
export default function VerifyAgeBanner() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [st, setSt] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("pandax_verify_banner_hidden") === "1");
  useEffect(() => {
    if (!user) return;
    api.get("/verify/status").then(({ data }) => setSt(data)).catch(() => {});
  }, [user, user?.age_verification_status, pathname]);
  if (!user || !st || hidden || pathname.startsWith("/verify") || !st.prompt || st.status === "verified" || st.status === "needs_review") return null;
  const label = st.status === "pending" ? "Finish your 18+ verification" : st.status === "failed" ? "Age verification needs attention" : "Verify you're 18+ — takes 2 minutes";
  return (
    <div className="mx-3 lg:mx-0 mt-3 rounded-2xl border border-rose-500/30 bg-rose-500/10 px-4 py-3 flex items-center gap-3" data-testid="verify-age-banner">
      <ShieldCheck size={18} className="text-rose-300 shrink-0" />
      <div className="text-sm text-rose-50 flex-1 min-w-0">
        <span className="font-semibold">{label}</span>
        <span className="hidden sm:inline text-rose-200/80"> · Private ID + selfie check via Persona. Nothing is shown on your profile.</span>
      </div>
      <Link to="/verify" className="text-xs font-semibold px-3 py-1.5 rounded-full bg-rose-600 text-white hover:bg-rose-500" data-testid="verify-age-banner-cta">{st.status === "none" ? "Verify" : "Open"}</Link>
      <button type="button" aria-label="Dismiss" className="text-rose-200/70 hover:text-white" data-testid="verify-age-banner-dismiss" onClick={() => { sessionStorage.setItem("pandax_verify_banner_hidden", "1"); setHidden(true); }}><X size={14} /></button>
    </div>
  );
}
